import { CUSTOM_SCROLLBAR_CSS } from "App/CUSTOM_SCROLLBAR_CSS";
import { getDashboardCardsResponsiveStyles } from "components/Dashboard/styles/getDashboardCardsResponsiveStyles";
import styled from "styled-components/macro";
import {
  NAV_HEIGHT_PX,
  Z_INDEX,
  BREAKPOINT_TABTOP,
  BREAKPOINT_TABLET,
  BREAKPOINT_DESKTOP_XL,
} from "../../constants/constants";
import { GRID_LAYOUT_MARGIN_OUTER } from "./gridLayoutPageUtils";

export const GridLayoutPageStyles = styled.div<{ $scale: number }>`
  height: calc(100vh - ${NAV_HEIGHT_PX}px);
  padding: ${GRID_LAYOUT_MARGIN_OUTER / 4}px;
  @media (min-width: ${BREAKPOINT_TABLET}px) {
    padding: ${GRID_LAYOUT_MARGIN_OUTER}px;
  }
  box-sizing: border-box;
  .gridItem {
    z-index: ${Z_INDEX.L1};
    touch-action: auto !important;
  }
  @media (max-width: ${BREAKPOINT_TABTOP}px) {
    overflow: auto;
    ${CUSTOM_SCROLLBAR_CSS}
  }
  @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
    ${props => getDashboardCardsResponsiveStyles(props.$scale)}
  }
`;
